import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import styled from "styled-components";

import Header from "../components/Header";
import "../styles/app.scss";
import Footer from "../components/Footer";
import slugify from "slugify";
import { PartnersBar } from "../components/PartnersBar";

const Body = styled.div`
  background-image: linear-gradient(-180deg, #ffffff 0%, #e6eaeb 100%);
  overflow-x: hidden;
  min-height: 100vh;
`;

const PageWrapper = styled.div`
  display: flex;
  height: 100%;
`;

const loadAboutMenu = pages =>
  pages.map(({ node: { pageTitle } }) => {
    const slug = `/about/${slugify(pageTitle, { lower: true })}`;
    return {
      name: pageTitle,
      slug
    };
  });

const eventTypes = events => {
  return Array.from(new Set(events.map(({ node }) => node.eventType))).map(
    eventType => ({ name: eventType, slug: `/events` })
  );
};

const jobRoles = jobs => {
  return Array.from(new Set(jobs.map(({ node }) => node.role)))
    .slice(0, 10)
    .map(role => ({ name: role, slug: `/jobs` }));
};

const TemplateWrapper = ({ data, children }) => (
  <Body>
    <Helmet>
      <meta charset="utf-8" />
      <title>Move To Nordics</title>
      <meta name="description" content="Your portal to the best tech ecosystem in the world." />
      <meta name="image" content="https://media.graphcms.com/resize=w:1600,fit:crop/output=format:jpg/compress/2Lv82o4zTZmoXnHx4hr7" />
      <meta itemprop="name" content="Move To Nordics" />
      <meta itemprop="description" content="Your portal to the best tech ecosystem in the world." />
      <meta itemprop="image" content="https://media.graphcms.com/resize=w:1600,fit:crop/output=format:jpg/compress/2Lv82o4zTZmoXnHx4hr7" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content="Move To Nordics" />
      <meta name="twitter:description" content="Your portal to the best tech ecosystem in the world." />
      <meta name="og:title" content="Move To Nordics" />
      <meta name="og:description" content="Your portal to the best tech ecosystem in the world." />
      <meta name="og:image" content="https://media.graphcms.com/resize=w:1200,fit:crop/output=format:jpg/compress/2Lv82o4zTZmoXnHx4hr7" />
      <meta name="og:url" content="https://movetonordics.com" />
      <meta name="og:site_name" content="Move To Nordics" />
      <meta name="og:type" content="website" />
      <link
        href="https://fonts.googleapis.com/css?family=Lato:300,400,400i,700,900|Poppins:700"
        rel="stylesheet"
      />
    </Helmet>
    <Header />
    <PageWrapper>{children()}</PageWrapper>
    <PartnersBar partners={data.partners.edges} />
    <Footer
      aboutMenu={loadAboutMenu(data.aboutMenu.edges)}
      eventTypes={eventTypes(data.events.edges)}
      jobRoles={jobRoles(data.jobs.edges)}
    />
  </Body>
);

export const AboutMenuQuery = graphql`
  query getAboutMenu {
    aboutMenu: allAboutPage {
      edges {
        node {
          pageTitle
        }
      }
    }
    events: allEvent {
      edges {
        node {
          eventType
        }
      }
    }
    jobs: allJob {
      edges {
        node {
          role
        }
      }
    }
    partners: allPartner {
      edges {
        node {
          id
          name
          link
          logo {
            handle
            width
            height
          }
        }
      }
    }
  }
`;

TemplateWrapper.propTypes = {
  children: PropTypes.func
};

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.js